"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
var _getDateText = _interopRequireDefault(require("../utils/getDateText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ReactSVGIcon = (0, _component.default)(function () {
  return import("@micado-digital/react-svg-icon/ReactSVGIcon");
});
var Grid = (0, _component.default)(function () {
  return import("@material-ui/core/Grid");
});
var Typography = (0, _component.default)(function () {
  return import("@micado-digital/react-ui/components/Typography");
});
var useStyles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette2, _root;
  return {
    root: (_root = {
      borderBottom: "1px solid " + (theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : _theme$palette.grey[400]),
      marginBottom: theme.spacing(4),
      paddingBottom: theme.spacing(4)
    }, _defineProperty(_root, theme.breakpoints.up("sm"), {
      borderBottom: "none",
      borderLeft: "1px solid " + (theme === null || theme === void 0 ? void 0 : (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.grey[400]),
      marginBottom: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      "&:first-child": {
        borderLeft: "none"
      }
    }), _defineProperty(_root, "&:last-child", {
      borderBottom: "none"
    }), _root),
    date: {
      marginBottom: theme.spacing(2),
      textAlign: "center"
    },
    text: _defineProperty({
      marginBottom: theme.spacing(2),
      textAlign: "center"
    }, theme.breakpoints.up("sm"), {
      padding: theme.spacing(0, 2)
    }),
    maxValue: _defineProperty({}, theme.breakpoints.up("sm"), {
      marginBottom: theme.spacing(4)
    }),
    iconWrapper: _defineProperty({
      justifyContent: "center",
      "& + div": {
        textAlign: "center"
      }
    }, theme.breakpoints.up("md"), {
      justifyContent: "flex-end",
      "& + div": {
        textAlign: "left"
      }
    }),
    icon: _defineProperty({
      margin: theme.spacing(1, 0, 2)
    }, theme.breakpoints.up("md"), {
      margin: theme.spacing(1, 2, 1, 0)
    })
  };
});
var Day = function Day(_ref) {
  var date = _ref.date,
    l = _ref.l,
    state = _ref.state,
    tempMax = _ref.tempMax,
    tempMin = _ref.tempMin,
    text = _ref.text;
  var css = useStyles();
  return /*#__PURE__*/_react.default.createElement(Grid, {
    className: (0, _clsx.default)("mco-weather-04__item", css.root),
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react.default.createElement(Typography, {
    className: css.date,
    variant: "overline",
    display: "block"
  }, (0, _getDateText.default)(new Date(date), l)), text && /*#__PURE__*/_react.default.createElement(Typography, {
    className: (0, _clsx.default)("mco-weather-04__item-text", css.text),
    variant: "body-small",
    display: "block",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), /*#__PURE__*/_react.default.createElement(Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(Grid, {
    className: css.maxValue,
    container: true,
    item: true,
    xs: 6,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(Grid, {
    className: (0, _clsx.default)("mco-weather-04__item-icon", css.iconWrapper),
    container: true,
    item: true,
    xs: 12,
    sm: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
    className: css.icon,
    color: "primary",
    size: 64,
    src: "/img/icons/weather/" + state + ".svg"
  }))), /*#__PURE__*/_react.default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: true,
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(Grid, {
    className: "mco-weather-04__item-value",
    item: true
  }, /*#__PURE__*/_react.default.createElement(Typography, {
    variant: "h4",
    component: "p"
  }, tempMax, "\xB0 C"), /*#__PURE__*/_react.default.createElement(Typography, {
    variant: "body2"
  }, l("reactWeather.maxValue")))))), /*#__PURE__*/_react.default.createElement(Grid, {
    container: true,
    item: true,
    xs: 6,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(Grid, {
    className: (0, _clsx.default)("mco-weather-04__item-icon", css.iconWrapper),
    container: true,
    item: true,
    xs: 12,
    sm: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
    className: css.icon,
    color: "primary",
    size: 64,
    src: "/img/icons/weather/" + state + ".svg"
  }))), /*#__PURE__*/_react.default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: true,
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(Grid, {
    className: "mco-weather-04__item-value",
    item: true
  }, /*#__PURE__*/_react.default.createElement(Typography, {
    variant: "h4",
    component: "p"
  }, tempMin, "\xB0 C"), /*#__PURE__*/_react.default.createElement(Typography, {
    variant: "body2"
  }, l("reactWeather.minValue"))))))));
};
Day.propTypes = {
  date: _propTypes.default.string,
  state: _propTypes.default.string,
  tempMax: _propTypes.default.number,
  tempMin: _propTypes.default.number,
  lang: _propTypes.default.string
};
var _default = Day;
exports.default = _default;